// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDqzasF5MNwTVnktSl2W3QXCUX1R2Aj1ZY",
  authDomain: "video-streaming-cfc82.firebaseapp.com",
  projectId: "video-streaming-cfc82",
  storageBucket: "video-streaming-cfc82.appspot.com",
  messagingSenderId: "512398897943",
  appId: "1:512398897943:web:226d1efbb61244924c3d52",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
